module.exports = __webpack_public_path__ + "img/ks_logo.f8ac3364.png";